const formStatuses = () => {
  return {
    APP_IN_REVIEW: 'Application in Review',
    APP_IN_COMPLETE: 'App Incomplete',
    APPROVED: 'Approved',
    TEMPORARY_APPROVED: 'Temporary Approved',
    SIGNING_IN_PROGRESS: 'Signing in Progress',
    ARCHIVED: 'Archived',
    NEED_REVISION: 'Need Revision',
  }
}

export default formStatuses;
